"use strict"

module.exports = require("blob-polyfill").Blob
